import { useEffect } from 'react';
import { useRachelScope } from '../contexts/RachelScope.context';
import { getRachelScopeKey } from '../effects/rachelScope';
import useRachelChangesStore from '../store/rachelChanges.store';
import { UseRachelListScrollParams } from './rachelEffects.types';

export const useRachelListScroll = <T>({
  items,
  getKey,
  scrollToItem,
}: UseRachelListScrollParams<T>) => {
  const scope = useRachelScope();
  const scopeKey = scope ? getRachelScopeKey(scope) : '';
  const scrollRequest = useRachelChangesStore((state) => state.scrollRequestByScope[scopeKey]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: scrolls once per Rachel request, against the list rendered with it
  useEffect(() => {
    if (!scope || !scrollRequest?.keys.length) {
      return;
    }

    const targetKeys = new Set(scrollRequest.keys);
    const farthestIndex = items.findLastIndex((item) => targetKeys.has(getKey(item)));

    if (farthestIndex !== -1) {
      scrollToItem(farthestIndex);
    }

    useRachelChangesStore.getState().requestScroll({ scope, keys: [] });
  }, [scrollRequest]);
};
